import  { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../components/UI/card";
import {  useNavigate, useLocation } from "react-router-dom";

import Spinner from "../components/UI/Spinner";
import OTPInput from "../components/OtpInput";

const OTPVerification = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isExistingUser = sessionStorage.getItem("isExistingUser") === "true";
  const hasFacility = !!localStorage.getItem("selectedFacilityId") || 
                      !!sessionStorage.getItem("qrFacilityId") ||
                      localStorage.getItem("hospitalSelected") === "true";
  
  const authState = JSON.parse(sessionStorage.getItem("authState") || "{}");
  const phoneNumber = authState.phoneNumber || localStorage.getItem("phoneNumber");
  const isForgotPassword = authState.ForgotPassword === true;
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const fromQR = location.state?.fromQR === true || localStorage.getItem("fromQR") === "true";
  const fromSpecializationQR = location.state?.fromSpecializationQR === true || localStorage.getItem("fromSpecializationQR") === "true";
  
  useEffect(() => {
  }, [authState, isForgotPassword]);

  const getNextStepMessage = () => {
    if (isForgotPassword) {
      return "reset your password...";
    } else if (isExistingUser) {
      return "sign in to your account...";
    } else {
      if (hasFacility) {
        return "create your account...";
      } else {
        return "select a hospital...";
      }
    }
  };

  const handleVerificationSuccess = () => {
    sessionStorage.setItem(
      "lastVerifiedPhone",
      phoneNumber.replace(/^\+251/, "")
    );
    localStorage.setItem("phoneVerified", "true");
    
    const originalIntendedPath = sessionStorage.getItem("originalIntendedPath");
    if (originalIntendedPath && originalIntendedPath.includes('/specializations/')) {
      localStorage.setItem("intendedPath", originalIntendedPath);
      
      const pathParts = originalIntendedPath.split('/');
      if (pathParts.length >= 4) {
        const specId = pathParts[2];
        sessionStorage.setItem("qrSpecializationId", specId);
        localStorage.setItem("fromSpecializationQR", "true");
        localStorage.setItem("specializationSelected", "true");
        
        if (pathParts.length >= 6) {
          const facId = pathParts[4];
          sessionStorage.setItem("qrFacilityId", facId);
          localStorage.setItem("selectedFacilityId", facId);
          localStorage.setItem("hospitalSelected", "true");
        }
      }
    }
    
    if (isForgotPassword) {
      window.location.href = "/reset-password";
    } else {
      if (isExistingUser) {
        const storedSpecPath = localStorage.getItem("intendedPath") || 
                               sessionStorage.getItem("originalIntendedPath") || 
                               sessionStorage.getItem("storedSpecializationPath");
        
        navigate("/auth?mode=signin", {
          state: {
            autoFillPhone: true,
            verifiedPhone: phoneNumber.replace(/^\+251/, ""),
            fromQR: fromQR,
            fromSpecializationQR: fromSpecializationQR,
            specializedPath: storedSpecPath
          },
          replace: true,
        });
      } else {
        if (hasFacility) {
          const storedSpecPath = localStorage.getItem("intendedPath") || 
                                sessionStorage.getItem("originalIntendedPath") || 
                                sessionStorage.getItem("storedSpecializationPath");
          
          navigate("/auth?mode=signup", {
            state: {
              autoFillPhone: true,
              verifiedPhone: phoneNumber.replace(/^\+251/, ""),
              fromQR: fromQR,
              fromSpecializationQR: fromSpecializationQR,
              specializedPath: storedSpecPath
            },
            replace: true,
          });
        } else {
          navigate("/hospitals", {
            state: {
              fromVerification: true,
              verifiedPhone: phoneNumber.replace(/^\+251/, ""),
              fromQR: fromQR,
              fromSpecializationQR: fromSpecializationQR
            },
            replace: true,
          });
        }
      }
    }
    
    localStorage.removeItem("otpVerificationId");
  };

  if (!phoneNumber) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Card className="w-full max-w-md">
          <CardHeader>
            <CardTitle>Error</CardTitle>
          </CardHeader>
          <CardContent>
            <p>Missing phone number for verification.</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <Card className="w-full max-w-md shadow-md">
        <CardHeader className="space-y-1 text-center">
          <CardTitle className="text-2xl font-bold">
            Phone Verification
          </CardTitle>
          <p className="text-gray-500">
            Enter the 4-digit code sent to your phone
          </p>
        </CardHeader>
        <CardContent className="space-y-6">
          {localStorage.getItem("fromSpecializationQR") === "true" && (
            <div className="bg-indigo-50 border-l-4 border-indigo-500 p-4 mb-4">
              <div className="flex">
                <div>
                  <p className="text-sm text-indigo-700">
                    After verification, you'll be able to view doctors in your selected specialization.
                  </p>
                </div>
              </div>
            </div>
          )}
          
          <OTPInput 
            phoneNumber={phoneNumber}
            onVerificationSuccess={handleVerificationSuccess}
            successMessage={`Phone verified successfully! Redirecting you to ${getNextStepMessage()}`}
            isSubmitting={isSubmitting}
            setIsSubmitting={setIsSubmitting}
          />
        </CardContent>
      </Card>
      
      {isSubmitting && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <Spinner message="Verifying..." />
        </div>
      )}
    </div>
  );
};

export default OTPVerification;